import { useMutation, useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import {
  addUser,
  deleteUser,
  getAllAlbum,
  getAllSubscriptions,
  getMusic,
  getUsers,
  updateUser,
} from "../utils/api";

import { UploadOutlined } from "@ant-design/icons";

import {
  Button,
  Form,
  Image,
  Input,
  Modal,
  Popconfirm,
  Table,
  Typography,
  Upload,
  message,
} from "antd";

import { useSearchParams } from "react-router-dom";
import useSearch from "../components/Search";
import Notifications from "../components/user/Notifications";
import RentHistory from "../components/user/RentHistory";
import Subscription from "../components/user/Subscription";
import Wallet from "../components/user/Wallet";
import { useAuth } from "../utils/store";

const Users = () => {
  const user = useAuth((state) => state.user);
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(Number(searchParams.get("page") || 1));

  // Effect to update URL when page changes
  useEffect(() => {
    searchParams.set("page", page.toString());
    setSearchParams(searchParams);
  }, [page, searchParams, setSearchParams]);

  const { data: musics } = useQuery({
    queryKey: ["musics"],
    queryFn: async () => await getMusic(),
  });
  const { data: albums } = useQuery({
    queryKey: ["albums"],
    queryFn: async () => await getAllAlbum(),
  });
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["users", page],
    queryFn: () => getUsers(page),
  });
  const { data: subs } = useQuery({
    queryKey: ["subscriptions"],
    queryFn: async () => await getAllSubscriptions(),
  });

  // Effect to update page state when URL changes
  useEffect(() => {
    const pageParam = searchParams.get("page");
    if (pageParam && Number(pageParam) !== page) {
      setPage(Number(pageParam));
    }
  }, [searchParams, page]);

  console.log(musics, user);
  const { mutate: deleteUserData, isLoading: deleteisLoading2 } = useMutation(
    async (values) => user?.deleteUsers && (await deleteUser(values)),
    {
      onSuccess: () => {
        message.success(`Deleted`);
        refetch();
      },
    }
  );
  const search = useSearch();
  const columns = [
    {
      title: "Actions",
      dataIndex: "action",
      render(value, record) {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",

              flexDirection: "column",
              gap: 10,
            }}
          >
            <Popconfirm
              title="Delete the task"
              description="Are you sure to delete this task?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => deleteUserData(record._id)}
            >
              <Button
                danger
                style={{ marginTop: 10 }}
                loading={deleteisLoading2}
              >
                Delete
              </Button>
            </Popconfirm>

            {/* {user?.userDownloads && (
              <Link to={`/download-history/${record?._id}`}>
                <Button
                  type="primary"
                  loading={deleteisLoading2}
                  style={{
                    width: "100%",
                  }}
                >
                  Downloads
                </Button>
              </Link>
            )} */}
            <AddData update={record} refech={refetch} page={page} />
            {/* {user?.userSoldRecords && <UserRecord row={record} type="sold" />}
            {user?.userPurchaseRecord && (
              <UserRecord row={record} type="purchased" />
            )} */}
            <RentHistory row={record} albums={albums} musics={musics} />
            <Wallet row={record} albums={albums} musics={musics} />
            <Subscription row={record} subs={subs} />
            <Notifications row={record} />
          </div>
        );
      },
    },

    {
      title: "Image",
      dataIndex: "image",
      render(value) {
        return <Image src={value} width={100} height={100} />;
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      ...search("name"),
    },
    {
      title: "Email",
      dataIndex: "email",
      ...search("email"),
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      ...search("phoneNumber"),
    },
    {
      title: "Wallet",
      dataIndex: "wallet",
    },
    {
      title: "Date of Birth",
      dataIndex: "dob",
    },
  ];

  return (
    <div
      style={{
        padding: 24,
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography style={{ fontSize: 20, fontWeight: 600, marginBottom: 10 }}>
          Users
        </Typography>
        <AddData refech={refetch} page={page} />
      </div>
      <Table
        columns={columns}
        dataSource={data?.users}
        loading={isLoading}
        scroll={{ x: 900 }}
        pagination={{
          total: data?.totalData,
          pageSize: 20,
          current: page,
          onChange: (e) => {
            setPage(e);
          },
          pageSizeOptions: ["20"],
        }}
      />
    </div>
  );
};

export default Users;

// const UserRecord = ({ row, type }) => {
//   const [visible, setVisible] = useState(false);
//   const { data, isLoading } = useQuery({
//     queryKey: ["user-record", row._id, visible],
//     queryFn: () =>
//       visible &&
//       (type === "sold"
//         ? getUserSellHistory(row._id)
//         : getUserPurchaseHistory(row._id)),
//   });
//   console.log(data);

//   return (
//     <div>
//       <Button
//         style={{
//           width: "100%",
//         }}
//         type="primary"
//         onClick={() => setVisible(true)}
//       >
//         {type === "sold" ? "Sold" : "Purchased"}
//       </Button>
//       <Modal
//         title={type === "sold" ? "Sold" : "Purchased"}
//         confirmLoading={isLoading}
//         open={visible}
//         onCancel={() => setVisible(false)}
//         footer={null}
//       >
//         <h1 style={{ textAlign: "center", fontSize: "20px" }}>Photos</h1>
//         <Table
//           dataSource={data?.photos}
//           columns={[
//             {
//               title: "Image",
//               dataIndex: ["photo", "low"],
//               render(value) {
//                 return <Image src={value} width={100} height={100} />;
//               },
//             },
//             {
//               title: "Date",
//               dataIndex: "createdAt",
//               render(value) {
//                 return (
//                   <span>
//                     {new Date(value).toLocaleDateString()}-{" "}
//                     {new Date(value).toLocaleTimeString()}
//                   </span>
//                 );
//               },
//             },
//             {
//               title: "Amount",
//               dataIndex: "amount",
//             },
//           ]}
//         />
//         <h1 style={{ textAlign: "center", fontSize: "20px" }}>Videos</h1>
//         <Table
//           dataSource={data?.videos}
//           columns={[
//             {
//               title: "Image",
//               dataIndex: ["video", "thumbnail"],
//               render(value) {
//                 return <Image src={value} width={100} height={100} />;
//               },
//             },
//             {
//               title: "Date",
//               dataIndex: "createdAt",
//               render(value) {
//                 return (
//                   <span>
//                     {new Date(value).toLocaleDateString()}-{" "}
//                     {new Date(value).toLocaleTimeString()}
//                   </span>
//                 );
//               },
//             },
//             {
//               title: "Amount",
//               dataIndex: "amount",
//             },
//           ]}
//         />
//       </Modal>
//     </div>
//   );
// };

const AddData = ({ refech, update, page }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const type = Form.useWatch("rewardType", form);

  const { mutate, isLoading } = useMutation(
    async (values) =>
      update ? await updateUser(update._id, values) : await addUser(values),
    {
      onSuccess: () => {
        messageApi.success(`Added`);
        //reset form
        !update && form.resetFields();
        refech();
        setVisible(false);
      },
      onError: (err) => {
        messageApi.error(err?.response?.data?.message);
      },
    }
  );
  console.log(update);
  return (
    <div>
      {contextHolder}
      <Button
        type="primary"
        onClick={() => setVisible(true)}
        style={{
          width: "100%",
        }}
      >
        {update ? "Update" : "Add"}
      </Button>
      <Modal
        title={update ? "Update User" : "Add User"}
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          labelCol={{ span: 9 }}
          layout="horizontal"
          style={{
            maxWidth: 600,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          initialValues={
            update && {
              name: update.name,
              email: update.email,
              phoneNumber: update.phoneNumber,
              dob: update.dob,
              wallet: update.wallet,
            }
          }
          onFinish={(values) => {
            console.log(values);

            const data = new FormData();
            if (values?.image && values?.image?.file?.originFileObj) {
              data.append("image", values.image.file.originFileObj);
            }

            data.append("name", values.name);
            data.append("email", values.email);
            if (!values?.phoneNumber?.includes("+91")) {
              data.append("phoneNumber", "+91" + values.phoneNumber);
            }

            data.append("dob", values.dob);
            data.append("wallet", values.wallet);

            mutate(data);
          }}
        >
          {" "}
          <Form.Item
            label="Name"
            name="name"
            required
            rules={[
              {
                required: true,
                message: "Please select name!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            required
            rules={[
              {
                required: true,
                message: "Please select email!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Dob"
            name="dob"
            required
            rules={[
              {
                required: true,
                message: "Please select dob!",
              },
            ]}
          >
            <Input type="date" />
          </Form.Item>
          <Form.Item
            label="Image"
            name="image"
            required
            rules={
              !update
                ? [
                    {
                      required: true,
                      message: "Please input your image!",
                    },
                  ]
                : []
            }
          >
            <Upload name="image">
              <Button icon={<UploadOutlined />}>Click to upload</Button>
            </Upload>
          </Form.Item>
          <Form.Item
            label="Phone Number"
            name="phoneNumber"
            required
            rules={[
              {
                required: true,
                message: "Please input your phone number!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
};
